import React from 'react'

import WallModel from './WallModel'
import TrimModel from './TrimModel'

const Storage = () => {

    return (
        <>
            <WallModel/>
            <TrimModel/>
        </>
    )
}

export default Storage